import React, { useState } from "react";

const DOORI_STAGES = {
  1: { name: "SPARK DOORI", message: "I wonder..." },
  2: { name: "SEEKER DOORI", message: "I am searching." },
  3: { name: "BRAVE DOORI", message: "I will try." },
  4: { name: "THINKER DOORI", message: "I can learn." },
  5: { name: "GUARDIAN DOORI", message: "I can endure." },
  6: { name: "CHARGER DOORI", message: "I can move." },
  7: { name: "FOCUS DOORI", message: "I stay on track." },
  8: { name: "CONNECTOR DOORI", message: "I grow together." },
  9: { name: "LEADER DOORI", message: "I guide." },
  10: { name: "CREATOR DOORI", message: "I build." },
  11: { name: "IMPACT DOORI", message: "I matter." },
  12: { name: "ASCENDED DOORI", message: "I have become." }
};

const getDOORIVisual = (week) => {
  if (week <= 2) return "🟣◐";
  if (week <= 4) return "🟣◑";
  if (week <= 6) return "🟣⬤";
  if (week <= 8) return "🟣⚙️";
  if (week <= 10) return "🟣✨";
  return "🟣🌌";
};

const PDDOORIContest = () => {
  const [week, setWeek] = useState(4);
  const [showDooriImage, setShowDooriImage] = useState(false);

  const stage = DOORI_STAGES[week];

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-black via-gray-900 to-black text-white px-3 py-4 rounded-2xl border-t-2 border-purple-600">
      {/* <button
        onClick={() => setViewTab(false)}
        className="w-fit absolute top-3 right-3 text-xs lg:text-sm text-gray-100 bg-gray-800 px-3 py-1 rounded-full hover:bg-purple-700"
      >
        Close
      </button> */}

      <div>
        <h2 className="text-xs lg:text-sm text-gray-100 font-semibold">
            PurpleDoor Original Mascot: DOORI 
        </h2>

        <p className="text-xs lg:text-sm text-gray-100 mt-2">
            A single creature that evolves every week as the user progresses through the 12-week streak.
        </p>

        <p className="text-xs lg:text-sm text-gray-100 mt-2">
            (DOORI is Derived from Discipline Opens Outstanding Results & Impact)
        </p>

        <p className="text-xs lg:text-sm text-gray-100 mt-2">
            The idea is that every human has a hidden potential creature inside them. As they complete the 12-week journey, DOORI evolves from a tiny spark into the Guardian of Possibilities.
        </p>

        <p className="text-xs lg:text-sm text-gray-100 mt-2">
            This is not a dragon, Pokémon, dinosaur, lion, unicorn, or any existing creature archetype. It is built around the PurpleDoor philosophy.
        </p>
      </div>
      <div className="text-center mb-6">
        <h1 className="text-lg lg:text-xl font-bold text-purple-300">
            DOORI EVOLUTION ENGINE
        </h1>

        <button
            onClick={() => setShowDooriImage((prev) => !prev)}
            className="mt-3 text-xs lg:text-sm w-fit px-2 py-1 mx-auto rounded-full bg-purple-700 hover:bg-purple-600 transition-colors"
        >
            🟣✨ View DOORI
        </button>

        {showDooriImage && (
            <div className="mt-4 bg-gray-900 border border-purple-700 rounded-xl p-3 relative">
                <button
                    onClick={() => setShowDooriImage(false)}
                    className="absolute top-2 right-2 text-xs lg:text-sm w-fit px-2 py-1 bg-gray-800 hover:bg-red-600 rounded-lg transition-colors"
                >
                    ✕
                </button>

                <img
                    src="/assets/purpledoor_doori.webp"
                    alt="DOORI Evolution Creature"
                    className="w-full max-w-md mx-auto rounded-xl border border-purple-500"
                />
            </div>
        )}
        <p className="text-xs lg:text-sm text-gray-100 mt-1">
          Week {week} / 12 Journey State
        </p>

        {/* EVOLUTION SLIDER */}
        <input
          type="range"
          min="1"
          max="12"
          value={week}
          onChange={(e) => setWeek(Number(e.target.value))}
          className="w-full mt-4 accent-purple-500"
        />

        <p className="text-xs lg:text-sm text-gray-100 mt-2">
          {stage.message}
        </p>
      </div>

      {/* DOORI CORE VISUAL */}
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-6 rounded-2xl text-center mb-4 border border-gray-700">

        <div className="text-5xl mb-2">
          {getDOORIVisual(week)}
        </div>

        <h2 className="text-sm lg:text-base text-purple-300 font-semibold">
          {stage.name}
        </h2>

        <p className="text-xs lg:text-sm text-gray-100 mt-1">
          Core Trait Evolution Active
        </p>
      </div>

      {/* PROGRESS */}
      <div className="w-full bg-gray-800 rounded-full h-2 mb-4 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-purple-500 to-pink-500"
          style={{ width: `${(week / 12) * 100}%` }}
        />
      </div>

      {/* QUICK INSIGHTS */}
      <div className="grid grid-cols-2 gap-3 mb-4">

        <div className="bg-gray-800 p-3 rounded-xl">
          <p className="text-xs lg:text-sm text-gray-100">State</p>
          <p className="text-xs lg:text-sm text-gray-100">{stage.name}</p>
        </div>

        <div className="bg-gray-800 p-3 rounded-xl">
          <p className="text-xs lg:text-sm text-gray-100">Message</p>
          <p className="text-xs lg:text-sm text-gray-100">{stage.message}</p>
        </div>

        <div className="bg-gray-800 p-3 rounded-xl">
          <p className="text-xs lg:text-sm text-gray-100">Evolution</p>
          <p className="text-xs lg:text-sm text-gray-100">
            {Math.round((week / 12) * 100)}%
          </p>
        </div>

        <div className="bg-gray-800 p-3 rounded-xl">
          <p className="text-xs lg:text-sm text-gray-100">Mode</p>
          <p className="text-xs lg:text-sm text-gray-100">Active Growth</p>
        </div>
      </div>

      {/* PHILOSOPHY FOOTER */}
      <div className="bg-gray-900 p-4 rounded-2xl border border-purple-800">
        <p className="text-xs lg:text-sm text-gray-100 mb-2">
          DOORI Philosophy
        </p>

        <p className="text-xs lg:text-sm text-gray-100">
          A living evolution system where consistency transforms identity.
          Each week unlocks a new layer of human potential.
        </p>
      </div>

    </div>
  );
};

export default PDDOORIContest;